import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { PageTabs } from '../../../../components'
import { CreatorRoutes } from '../../../CreatorRoutes'

const Header = () => {
  const { id } = useParams()

  const navigation = useMemo(
    () => [
      {
        text: 'Active Campaigns',
        count: null,
        to: CreatorRoutes.collaborations.replace(':id', `${id}`),
      },
      {
        text: 'Applications',
        count: null,
        to: CreatorRoutes.applications.replace(':id', `${id}`),
      },
    ],
    [id],
  )

  return (
    <div className='flex flex-col px-1'>
      <div className='grid grid-cols-1 lg:flex lg:flex-row lg:justify-between mt-5'>
        <div className='col-span-1'>
          <div className='flex flex-row justify-between'>
            <h1 className='font-bold text-3xl font-outfit'>Active Campaigns</h1>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <PageTabs
        navigation={navigation}
        menuPosition='right'
        className='my-4 md:mt-0'
      />
    </div>
  )
}

export { Header }
